/*
* Copyright (C) Regione Lombardia
*/
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoreAuthGuard } from '@core/guards/auth.guard';
import { PagesHomeComponent } from '@pages/home/home.component';
import { PagesSystemAuthComponent } from '@pages/system/auth/auth.component';
import { PagesSystemRouterComponent } from '@pages/system/router/router.component';
import { PagesViewerComponent } from '@pages/viewer/viewer.component';

const routes: Routes = [
    { path: '', redirectTo: 'auth', pathMatch: 'full' },
    { path: 'auth', component: PagesSystemAuthComponent, },
    { path: 'home', component: PagesHomeComponent, },
    { path: 'cms', loadChildren: () => import('./pages/cms/cms.module').then(m => m.PagesCmsModule), },
    {
        path: 'private',
        component: PagesSystemRouterComponent,
        canActivate: [ CoreAuthGuard ],
        children: [
            {
                path: 'gestione-opera',
                loadChildren: () => import('./pages/gestione-opera/gestione-opera.module').then(m => m.PagesGestioneOperaModule),
            },
            {
                path: 'gestione-anagrafica',
                loadChildren: () => import('./pages/gestione-anagrafica/gestione-anagrafica.module').then(m => m.PagesGestioneAnagraficaModule),
            },
            {
                path: 'gestione-progetto',
                loadChildren: () => import('./pages/gestione-progetto/gestione-progetto.module').then(m => m.PagesGestioneProgettoModule),
            },
            {
                path: 'gestione-rilievo',
                loadChildren: () => import('./pages/gestione-rilievo/gestione-rilievo.module').then(m => m.PagesGestioneRilievoModule),
            },
            {
                path: 'gestione-utente',
                loadChildren: () => import('./pages/gestione-utente/gestione-utente.module').then(m => m.PagesGestioneUtenteModule),
            },
            { path: 'viewer', component: PagesViewerComponent, },
            { path: '', redirectTo: 'gestione-opera', pathMatch: 'full' },
            { path: '**', redirectTo: 'gestione-opera', pathMatch: 'full' },
        ],
    },
    { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        enableTracing: false,
        onSameUrlNavigation: 'reload',
        scrollPositionRestoration: 'top',
        useHash: true
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
